import _IconError from "@arco-design/iconbox-react-m4b-next/esm/IconError";
import _IconWarning from "@arco-design/iconbox-react-m4b-next/esm/IconWarning";
import _IconSuccess from "@arco-design/iconbox-react-m4b-next/esm/IconSuccess";
import _IconInfoBlue from "@arco-design/iconbox-react-m4b-next/esm/IconInfoBlue";
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React, { forwardRef } from 'react';
import { ArcoIconWrapper } from '@m4b-design/utils';
import { Modal as ArcoModal } from '@arco-design/web-react';
import './style/modal.less';
import confirm from './confirm';
import { normalizeConfig } from './utils';
import { useModal } from './useModal';
var ModalRender = function ModalRender(props, ref) {
  return /*#__PURE__*/React.createElement(ArcoModal, __assign({
    "data-tid": "m4b_modal"
  }, normalizeConfig(props), {
    ref: ref
  }));
};
var Modal = /*#__PURE__*/forwardRef(ModalRender);
Modal.displayName = 'Modal';
var iconMap = {
  info: /*#__PURE__*/React.createElement(ArcoIconWrapper, {
    Icon: _IconInfoBlue
  }),
  success: /*#__PURE__*/React.createElement(ArcoIconWrapper, {
    Icon: _IconSuccess
  }),
  warning: /*#__PURE__*/React.createElement(ArcoIconWrapper, {
    Icon: _IconWarning
  }),
  error: /*#__PURE__*/React.createElement(ArcoIconWrapper, {
    Icon: _IconError
  })
};
var ExportedModalComponent = Modal;
ExportedModalComponent.confirm = confirm;
['info', 'success', 'warning', 'error'].forEach(function (type) {
  ExportedModalComponent[type] = function (props) {
    var _a, _b;
    return confirm(__assign(__assign({}, props), {
      icon: (_b = (_a = props.icon) !== null && _a !== void 0 ? _a : iconMap[type]) !== null && _b !== void 0 ? _b : type
    }));
  };
});
ExportedModalComponent.config = ArcoModal.config;
ExportedModalComponent.destroyAll = ArcoModal.destroyAll;
ExportedModalComponent.useModal = useModal;
export default ExportedModalComponent;